export default __webpack_public_path__ + "static/media/laurels.1f841cb4.png";